"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * attaches configuration for opening link destination in a new popup-window
 * currently used in EXT:gs1_vacancies
 * @see GSONE-1528
 *
 * @namespace
 * @memberOf txGs1Base.content
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.content.popupLinks = {
    /**
     * Init function
     *
     * @namespace
     * @memberOf txGs1Base.content.popup
     * @public
     */
    initialize: function () {
        'use strict';
        $('.popup-link').on('click', function () {
            window.open($(this).attr('href'), 'AppWin', 'toolbar=0,status=0,menubar=0,scrollbars=1,resizable=1,width=800,height=900,DEPENDENT=YES').focus();
            return false;
        });
    }
};
exports.default = {};
